import React, { FC, useEffect, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
// components
import SearchField from '../../atoms/searchField';
import EmptyList from '../../atoms/emptyList';
// actions
import patientAction from '../../../redux/actions/patient';
import patientsAction from '../../../redux/actions/patients';
// types
import { patientType } from '../../../types/patient';
import { patientsResponseType } from '../../../types/patients';
import { loadingType } from '../../../types/types';
// style
import './index.scss';

interface PatientsListProps {
  patients: patientsResponseType;
  patient: patientType;
  patientsLoading: loadingType;
  disabled: boolean;
}

const PatientsList: FC<PatientsListProps> = ({ patients, patient, patientsLoading, disabled }: PatientsListProps) => {
  const [committedSearch, setCommittedSearch] = useState<string>('');
  const [isLoadingFinished, setIsLoadingFinished] = useState<boolean>(false);
  const searchLetterRef = useRef('');

  const dispatch = useDispatch();

  const data = { first: 6, skip: 0, letter: '' };

  const handlePatient = (id: number) => {
    dispatch(patientAction.getPatientAction(id));
  };
  const listDisabled = disabled || patientsLoading.status;
  const patientsListClassName = `patients__list${listDisabled ? ' disabled' : ''}`;

  useEffect(() => {
    patientsLoading.progress === 100 && setIsLoadingFinished(true);
  }, [patientsLoading]);

  const handleSearch = (value: string) => {
    searchLetterRef.current = value;
    setCommittedSearch(value);
    dispatch(patientsAction.getPatientsAction({ ...data, letter: value }));
  };

  // Fetches the next page of patients when the list is scrolled to (or near) the bottom.
  const handleBottomScroll = (e: React.UIEvent<HTMLElement>) => {
    const el = e.currentTarget;
    const scrollBottomSlackPx = 4;
    const isNearBottom = el.scrollTop + el.clientHeight >= el.scrollHeight - scrollBottomSlackPx;

    if (!patientsLoading.status && isNearBottom && patients.patientCounter > patients.doctorPatients.length) {
      dispatch(
        patientsAction.getPatientsAction({
          ...data,
          skip: patients.skip + 6,
          letter: searchLetterRef.current,
          doctorPatients: patients.doctorPatients,
        }),
      );
    }
  };

  return (
    <div className="patients">
      <div className="patients__header">
        <h3 className="page-heading small">Patients list</h3>
        <SearchField handleSearch={handleSearch} disabled={disabled} loading={patientsLoading.status} />
      </div>
      {patients.doctorPatients.length ? (
        <div className={patientsListClassName} onScroll={handleBottomScroll}>
          {patients.doctorPatients.map((item) => (
            <div
              className={`patients__list-item${patient.patientName === item.name ? ' active' : ''}`}
              key={item.id}
              onClick={() => !listDisabled && handlePatient(item.id)}
            >
              <span>{item.name}</span>
            </div>
          ))}
        </div>
      ) : (
        !patientsLoading.status &&
        isLoadingFinished && (
          <EmptyList
            isEmpty={committedSearch.length === 0}
            value="You do not have any patients yet. Please add new patient"
          />
        )
      )}
    </div>
  );
};

export default PatientsList;
